export default __webpack_public_path__ + "static/media/superchef_logo.74b54dc0.png";